module.exports = __webpack_public_path__ + "media/images/common/right_product_box_bg-a56c9cadc8744854868bdeae13c06710.gif";